import React, { useContext } from 'react';
import { RemoveConnectionTriggerWrap } from '../style';
import { SchemaDisplayContext } from '../context';

function RemoveConnectionTrigger(props) {
  const { plaza: { isActive, locked }, schema: { removeConnection } } = useContext(SchemaDisplayContext);
  const { connection: { start, end, targetId } } = props;

  return (removeConnection && isActive && !locked) ? (
    <RemoveConnectionTriggerWrap
      onClick={() => removeConnection(targetId)}
      x={(start.x + end.x) / 2 - 4}
      y={(start.y + end.y) / 2 - 4}
    >
      <path d="M 0 0 L 8 8" />
      <path d="M 0 8 L 8 0" />
      <rect />
    </RemoveConnectionTriggerWrap>
  ) : null;
}

export default RemoveConnectionTrigger;
